import React, {useState} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import {Modal} from "peggirkit";
import {KeyphraseDistributionScore} from "./KeyphraseDistributionChecker";
import ScoreIndicator from "../../../../elements/scoreIndicator/ScoreIndicator";
import {globalModalStyling} from "../../../../elements/modal/modalStyle";

type Props = {
    result?: KeyphraseDistributionScore
};

const KeyphraseDistributionScoreIndicator = ({result}: Props) => {
    const intl = useIntl();
    const [showExplanation, setShowExplanation] = useState(false);

    if (!result) {
        return <>-</>;
    }

    return (
        <>
            <ScoreIndicator
                score={result.score}
                onClick={() => setShowExplanation(true)}
            />

            <Modal
                {...globalModalStyling(intl)}
                show={showExplanation}
                onClose={() => setShowExplanation(false)}
                title={intl.formatMessage({id: "keyphraseDistribution"})}
            >
                <div className={"flex flex-col gap-6"}>
                    <p>
                        <FormattedMessage id="keyphraseDistribution.description-1"/>
                    </p>
                    <p>
                        <FormattedMessage id="keyphraseDistribution.description-2"/>
                    </p>
                    <p>
                        <FormattedMessage id="keyphraseDistribution.description-3"/>
                    </p>
                    <p>
                        <span className={"text-black dark:text-white font-medium"}>
                            <FormattedMessage
                                id="keyphraseDistribution.description-4"
                                values={{
                                    averageDistance: result.averageDistance,
                                    keywordDistance: result.keywordDistance,
                                    percentageDifference: result.percentageDifference
                                }}
                            />
                        </span>
                    </p>
                </div>
            </Modal>
        </>
    );
};

export default KeyphraseDistributionScoreIndicator;